import { combineReducers } from 'redux';
import settingReducer from './settingsreducer';
import unitreducer from './unitsreducer';
import currencyreducer from './currencyreducer';

export const combinedreducer = combineReducers({
    'settingreducer':settingReducer,
    'unitreducer':unitreducer,
    'currencyreducer':currencyreducer   
});
